import React from 'react';
import { Divider, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import ClassOutlinedIcon from '@mui/icons-material/ClassOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';

const StudentSideBar = () => {
    const location = useLocation();

    const menuItems = [
        { path: '/', label: 'Home', icon: <HomeIcon /> },
        { path: '/student/subjects', label: 'Subjects', icon: <AssignmentIcon /> },
        { path: '/student/attendance', label: 'Attendance', icon: <ClassOutlinedIcon /> },
        { path: '/student/complain', label: 'Complain', icon: <AnnouncementOutlinedIcon /> },
    ];

    const userItems = [
        { path: '/Student/profile', label: 'Profile', icon: <AccountCircleOutlinedIcon /> },
        { path: '/logout', label: 'Logout', icon: <ExitToAppIcon /> },
    ];

    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <div style={{ 
            width: '100%', 
            backgroundColor: '#004d40', // Deep Teal Background
            minHeight: '100vh',
            padding: '10px',
            boxShadow: '4px 0 10px rgba(0, 0, 0, 0.2)',
            borderRadius: '10px'
        }}>
            {menuItems.map(({ path, label, icon }) => (
                <ListItemButton 
                    key={path} 
                    component={Link} 
                    to={path}
                    sx={{
                        backgroundColor: isActive(path) ? '#ffcc00' : 'transparent', // Gold for active
                        color: isActive(path) ? '#004d40' : '#fff', // Teal text on gold
                        borderRadius: '8px',
                        marginBottom: '8px',
                        '&:hover': { 
                            backgroundColor: '#ffeb3b', // Brighter Gold on hover
                            transform: 'scale(1.05)',
                            transition: '0.3s'
                        }
                    }}
                >
                    <ListItemIcon sx={{ color: isActive(path) ? '#004d40' : '#ffcc00' }}>
                        {React.cloneElement(icon, { color: 'inherit' })}
                    </ListItemIcon>
                    <ListItemText primary={label} sx={{ fontWeight: isActive(path) ? 'bold' : 'normal' }} />
                </ListItemButton>
            ))}

            <Divider sx={{ my: 2, backgroundColor: '#ffcc00' }} />

            <ListSubheader component="div" inset sx={{ color: '#ffcc00', fontSize: '16px' }}>
                User
            </ListSubheader>

            {userItems.map(({ path, label, icon }) => (
                <ListItemButton 
                    key={path} 
                    component={Link} 
                    to={path}
                    sx={{
                        backgroundColor: isActive(path) ? '#ffcc00' : 'transparent',
                        color: isActive(path) ? '#004d40' : '#fff',
                        borderRadius: '8px',
                        marginBottom: '8px',
                        '&:hover': { 
                            backgroundColor: '#ffeb3b',
                            transform: 'scale(1.05)',
                            transition: '0.3s'
                        }
                    }}
                >
                    <ListItemIcon sx={{ color: isActive(path) ? '#004d40' : '#ffcc00' }}>
                        {React.cloneElement(icon, { color: 'inherit' })}
                    </ListItemIcon>
                    <ListItemText primary={label} sx={{ fontWeight: isActive(path) ? 'bold' : 'normal' }} />
                </ListItemButton>
            ))}
        </div>
    );
};

export default StudentSideBar;
